import { Helmet } from 'react-helmet'
import { Navigate } from 'react-router'

import { Container } from '@/components/Container'
import { QuoteCartProvider } from '@/components/quotes/QuoteCartContext'
import { SkeletonRows } from '@/components/ui/skeleton'
import { isOrgAdmin } from '@/models/user'
import { InsuranceApplicationNav } from '../InsuranceApplication/InsuranceApplicationNav'
import { useCustomerApplication } from '../InsuranceApplication/useCustomerApplication'
import { ConfirmInfoView } from './ConfirmInfoView'
import { ShareApplicationButton } from './ShareApplicationButton'
import { useLinkedOrg } from './useLinkedOrg'

/** The customer's review of their whole application, at one URL for every way of applying. */
export function ConfirmInfoPage() {
  const { user, application, isLoading, showsQuotes } = useCustomerApplication()
  const switchingOrg = useLinkedOrg(user)
  const canReview = !!user && !!application && isOrgAdmin(user)

  // The nav reads the cart, though only /quotes fills it.
  return (
    <QuoteCartProvider>
      <Helmet>
        <title>Review your application</title>
      </Helmet>
      <InsuranceApplicationNav
        action={
          canReview && !showsQuotes && !switchingOrg ? (
            <ShareApplicationButton orgId={user.currentOrg.id} orgName={user.currentOrg.name} />
          ) : undefined
        }
      />
      <Container className="mt-10 flex flex-1 flex-col pb-20">
        {!user || isLoading || switchingOrg ? (
          <SkeletonRows className="mt-10" rows={6} rowClassName="h-16" />
        ) : !canReview ? (
          <Navigate to="/insure/insurance" replace />
        ) : showsQuotes ? (
          <Navigate to="/quotes" replace />
        ) : (
          <ConfirmInfoView orgId={user.currentOrg.id} />
        )}
      </Container>
    </QuoteCartProvider>
  )
}
